import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  optionsDefaultValue: [],
  workLocationList: [],
};

export const workLocationManageSlice = createSlice({
  name: "workLocationManage",
  initialState,
  reducers: {
    optionsDefaultValue: (state, action) => {
      state.optionsDefaultValue = action.payload;
    },
    workLocationList: (state, action) => {
      state.workLocationList = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { optionsDefaultValue, workLocationList } =
  workLocationManageSlice.actions;

export default workLocationManageSlice.reducer;
